import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ShieldAlert } from "lucide-react";
import SiteBuilderPage from "@/pages/web/SiteBuilderPage";

// Phase 82 — admin : édition d'assistance d'un mini-site client (via `sid`)
export default function AdminWebSiteEdit() {
  const { sid } = useParams();
  return (
    <div data-testid="admin-web-edit">
      <div className="px-6 lg:px-10 py-2 bg-[#0A0A0A] text-white text-xs flex flex-wrap items-center gap-3" data-testid="admin-web-edit-banner">
        <Link to="/admin/web" className="inline-flex items-center gap-1 font-bold text-[#FFD700] hover:underline" data-testid="admin-web-edit-back"><ArrowLeft className="h-3.5 w-3.5" /> Tous les sites</Link>
        <span className="inline-flex items-center gap-1.5"><ShieldAlert className="h-3.5 w-3.5 text-[#FFD700]" /> Mode assistance PAG : vous éditez le site d'un client — chaque enregistrement est appliqué immédiatement.</span>
      </div>
      <SiteBuilderPage sid={sid} eyebrow="Assistance admin" title="Site client" />
    </div>
  );
}
